import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useTheme } from "@/comn/hooks";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { APIS, SF_OGA_USR_SRCH, SG_OGA_USR_LIST, URLS } from "@/tra/tancis/ptli/ptl/orgauth/services/PtliOgaAuthService";

/*
 * OGA User Auth Management List
 * !== OGA 사용자 권한 관리 목록 ==!
 */
export const PTLI1008001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    }); 
    const modal = useModal();
    const { theme } = useTheme();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    useResource({ defaultSchema: [{ area: "orgCd" }] });

    const form = {
        ogaUsrSrch: useForm({ defaultSchema: SF_OGA_USR_SRCH }),
    };

    const grid = {
        gridOgaUsrList: useGrid({
            defaultSchema: SG_OGA_USR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getOgaUsrList: useFetch({
            api: (page = grid.gridOgaUsrList.page, size = grid.gridOgaUsrList.size) =>
                APIS.getOgaUsrList(form.ogaUsrSrch.getValues(), page, size),
            enabled: form.ogaUsrSrch.isSubmitted,
            key: [grid.gridOgaUsrList.page, grid.gridOgaUsrList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    ...pgeStore,
                    form: form.ogaUsrSrch.getValues(),
                    page: grid.gridOgaUsrList.page,
                    size: grid.gridOgaUsrList.size,
                });
            },
            onError: () => modal.openModal({ content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        ogaUsrList: {
            cell: {
                usrNm: (props: any) => {
                    const { value, rowValues } = props;
                    return <Link to={`${URLS.ptli1008002s}/${rowValues.tin}`}>{value}</Link>;
                },
            },
        },
    };

    const handler = {
        onSrchClick: form.ogaUsrSrch.handleSubmit(() => fetch.getOgaUsrList.fetch()),
        onClear: () => {
            form.ogaUsrSrch.clearValues();

            grid.gridOgaUsrList.getData().length > 0 && grid.gridOgaUsrList.clearData();
        }
    };

    useEffect(() => {
        pgeStore?.form && form.ogaUsrSrch.setValues(pgeStore.form);
        pgeStore?.form && handler.onSrchClick();
    }, [theme]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.ogaUsrSrch.schema.orgCd} />
                            <Group.Control {...form.ogaUsrSrch.schema.tin} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ogaUsrSrch.schema.usrNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Title title={"T_OGA_USR_LIST"} />
                    <Grid
                        {...grid.gridOgaUsrList.grid}
                        data={fetch.getOgaUsrList.data?.ogaUsrList}
                        render={render.ogaUsrList}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
